module.exports = __webpack_public_path__ + "static/img/qrcode.4adc21d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SharePrinting/qrcode.png
// module id = S51X
// module chunks = 10